import $ from "jquery";

//Programatically opening and closing foundation reveal
//Setting focus to the correct open modal button
var revealPhotosModal = $('#photoGalleryModal');
var revealVideosModal = $('#videoGalleryModal');
let buttonPhotoID;
let buttonVideoID;


$(".media-gallery-block").on("click", '.media-gallery-block_image-modal-btn', function (e) {
    var currentButton = $(this);
    if(currentButton.length){
        var nodeguid = $(currentButton[0]).data("nodeguid");
        revealPhotosModal = "#photoGalleryModal-" + nodeguid;
        $(revealPhotosModal).foundation();
        $(revealPhotosModal).foundation('open');
        buttonPhotoID = currentButton;
    }
});

function closePhotoModal()
{
    $(".amenities-photo-modal").each(function(index, elem){
        $(elem).on('closed.zf.reveal', function () {
            $(buttonPhotoID).focus();
        });
    });
}
closePhotoModal();
window.closePhotoModal = closePhotoModal;

$(".media-gallery-block").on("click", '.media-gallery-block_video-modal-btn', function (e) {
    var currentButton = $(this);
    var currentAmenityVideo = currentButton.attr('data-amenity-video');
    var currentAmenityPoster = currentButton.attr('data-amenity-poster');
    var currentAmenityAltText = currentButton.attr('data-amenity-alttext');
    var currentAmenityCaption = currentButton.attr('data-amenity-caption');

    var currentAmenity = currentButton.attr('data-amenity');
    var revealAmenityModal = revealVideosModal;

    if(currentAmenityCaption !== "")
    {
        $("#amenities-captions").show();
        $("#amenities-media-caption").html(currentAmenityCaption);
    }else{
        $("#amenities-captions").hide();
    }
    

    $(revealAmenityModal).find("source").attr("src", currentAmenityVideo);
    $(revealAmenityModal).find("video").attr("poster",currentAmenityPoster);
    $(revealAmenityModal).find("video").attr("alt",currentAmenityAltText); 
    $(revealAmenityModal).find("video")[0].load();
    $(revealAmenityModal).foundation('open');
    $(revealAmenityModal).addClass(currentAmenity);
    buttonVideoID = $(this);
});

function closeVideoModal()
{
    $(revealVideosModal).on('closed.zf.reveal', function () {
        $(buttonVideoID).focus();
    });
}
closeVideoModal();
window.closeVideoModal = closeVideoModal;
